module.exports = __webpack_public_path__ + "static/img/choose-us-1.d2cd85c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/choose-us-1.png
// module id = KWhZ
// module chunks = 0